const languageSelect = document.querySelector("[data-js='language-select']");

if (languageSelect) {
  const languageSelectValue = languageSelect.querySelector(".js-language-select-value");

  languageSelectValue.addEventListener("change", (e) => {
    languageSelect.submit();
  });
}
